import React, { useEffect } from 'react';
import { useSeasonTheme } from 'context/SeasonThemeContext';
import spiderWebSvg from 'assets/images/themes/halloween/spider-web.svg';
import fogPng from 'assets/images/themes/halloween/fog.png';

const HalloweenEffect = () => {
    const { seasonTheme } = useSeasonTheme();

    useEffect(() => {
        if (seasonTheme === 'halloween') {
            document.body.classList.add('halloween-theme');
        } else {
            document.body.classList.remove('halloween-theme');
        }

        return () => {
            document.body.classList.remove('halloween-theme');
        };
    }, [seasonTheme]);

    if (seasonTheme !== 'halloween') return null;

    return (
        <div className="pointer-events-none fixed inset-0 z-[9998]">
            {/* Fumée en bas de l'écran */}
            <div className="absolute bottom-0 left-0 w-full h-full z-[9997] overflow-hidden">
                <div 
                    className="w-full h-full bg-repeat-x animate-fog-drift opacity-60"
                    style={{
                        backgroundImage: `url(${fogPng})`,
                        backgroundSize: '200% 100%',
                        backgroundPosition: '0% 0%'
                    }}
                />
                <div 
                    className="w-full h-full bg-repeat-x animate-fog-drift-slow opacity-40"
                    style={{
                        backgroundImage: `url(${fogPng})`,
                        backgroundSize: '300% 100%',
                        backgroundPosition: '100% 0%'
                    }}
                />
            </div>

            {/* Toiles d'araignée dans les coins avec SVG */}
            <div className="absolute top-0 left-0 size-16 opacity-60">
                <img 
                    src={spiderWebSvg} 
                    alt="Toile d'araignée" 
                    className="w-full h-full"
                />
            </div>
            <div className="absolute bottom-0 right-0 size-20 opacity-40 rotate-180">
                <img 
                    src={spiderWebSvg} 
                    alt="Toile d'araignée" 
                    className="w-full h-full"
                />
            </div>
        </div>
    );
};

export default HalloweenEffect;
